export const COMMAND_HELP = {
  basics: [
    { cmd: "help", desc: "Show this help message" },
    { cmd: "clear", desc: "Clear terminal screen and history" },
    { cmd: "ls -la", desc: "List all items" },
    { cmd: "blogs", desc: "Show only blogs section" },
    { cmd: "projects", desc: "Show only projects section" },
    { cmd: "info", desc: "Show only info section" },
    {
      cmd: "blogs | projects",
      desc: "Show multiple sections (separated by |)",
    },
  ],
  flags: [
    {
      cmd: "--top",
      desc: "Show top 5 projects and blogs (sorted by rank)",
      usage: "ls -la --top",
    },
    {
      cmd: "--tag <tag>",
      desc: "Filter by tags (projects: techIcons/Cloud, blogs: metaTags)",
      usage: "ls -la --tag react",
    },
    {
      cmd: "--search <term>",
      desc: "Search in titles and descriptions",
      usage: "ls -la --search portfolio",
    },
    {
      cmd: "--sort <field>",
      desc: "Sort by field (time/rank/name, prefix with - for desc)",
      usage: "ls -la --sort -time",
    },
    {
      cmd: "--limit <number>",
      desc: "Limit number of items shown",
      usage: "ls -la --limit 10",
    },
  ],
  examples: [
    {
      cmd: "ls -la --tag react --sort -time",
      desc: "Show React projects/blogs, newest first",
    },
    {
      cmd: "ls -la --search api --limit 5",
      desc: "Show 5 items containing 'api'",
    },
    { cmd: "ls -la --top", desc: "Show top 5 projects and blogs" },
  ],
}

export const COMMANDS = {
  "~ $": "Click to see editable example commands",
  help: "Show all available commands",
  clear: "Clear terminal screen and history",
  "ls -la": "List all items",
  "ls -la --top": "Show top 5 projects and blogs",
  "--tag":
    "Filter by tags (for projects: techIcons/Cloud, for blogs: metaTags)",
  "--search": "Search in titles and descriptions",
  "--sort":
    "Sort by time/rank/name (prefix with - for desc: -time/-rank/-name)",
  "--limit": "Limit number of items shown",
}

export const QUICK_COMMANDS = ["ls -la", "clear", "ls -la --top", "help"]
